import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const NumeroAutorizacionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('inputDate-fechaUso', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='N° AUTORIZACION' htmlFor='input-numeroAutorizacion' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='numeroAutorizacion'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-numeroAutorizacion'
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroAutorizacionFormGroup)
